import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import './subscription.scss';
import { getSubscriptionData } from '../reducer';
import {
  loadSubscriptionById, loadSubscriptionByIdClear, loadSubscriptionList,
} from '../actions';
import TextInput from '../../../components/fields/TextInput/TextInput';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import PageHeader from '../../../components/base/PageHeader/PageHeader';
import {
  responseLogWithNotification,
  getPaginationOpts,
  getJsonFromStorage,
  useUpdatePeriod,
} from '../../../utils/utils';
import Loader from '../../../components/base/Loader/Loader';
import { getSystemData } from '../../System/reducer';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import { subscriptionColumns } from '../constants';
import Pagination from '../../../components/base/Pagination/Pagination';
import SeparateBox from '../../../components/base/SeparateBox/SeparateBox';
import IconBox from '../../../components/common/IconBox';
import SubscriptionForm from './SubscriptionForm';
import SubscriptionDTO from '../../../dto/SubscriptionDTO';

export default function SubscriptionListPage() {
  const dispatch = useDispatch();
  const [isCreate, setCreate] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showView, setShowView] = useState(false);
  const {
    subscriptionList,
    subscriptionListMeta,
    loadingSubscriptionList,
    currentSubscription,
    loadingCurrentSubscription,
    loadingCreateSubscription,
    loadingEditSubscription,
    loadingDeleteSubscription,
    loadingIntervalList,
    loadingCreateInterval,
    loadingEditInterval,
    loadingDeleteInterval,
  } = useSelector(getSubscriptionData);

  const { updatePeriod } = useSelector(getSystemData);

  const initial = getJsonFromStorage('subs-filter', {});
  const { getValues, watch, control } = useForm({ defaultValues: { ...initial } });

  const loadData = opts => {
    const filterData = getValues();
    const paginationOpts = getPaginationOpts(subscriptionListMeta, opts);
    const requestData = {
      ...paginationOpts,
      filter: filterData,
    };
    const p1 = dispatch(loadSubscriptionList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };
  const [setPeriod, destroy] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => {
    setPeriod(updatePeriod);
    return destroy;
  }, [updatePeriod]);

  useEffect(() => {
    const subscription = watch(values => { loadData(); });
    return () => subscription.unsubscribe();
  }, [watch]);

  const handleCreate = () => {
    setCreate(true);
    setShowForm(true);
  };

  const handleView = item => e => {
    dispatch(loadSubscriptionById(item.id))
      .then(() => {
        setShowForm(false);
        setCreate(false);
        setShowView(true);
      })
      .catch(responseLogWithNotification);
    e.preventDefault();
    e.stopPropagation();
  };

  const handleEdit = item => e => {
    dispatch(loadSubscriptionById(item.id))
      .then(() => {
        setShowView(false);
        setCreate(false);
        setShowForm(true);
      })
      .catch(responseLogWithNotification);
    e.preventDefault();
    e.stopPropagation();
  };

  const handleClose = () => {
    dispatch(loadSubscriptionByIdClear());
    setShowForm(false);
    setShowView(false);
    setCreate(false);
  };

  const subscriptionDTO = new SubscriptionDTO();
  const attributes = subscriptionDTO.getAttributesByName();

  const renderList = () => (
    <div className="page-container subscription-list-container">
      <div className="inputs-box">
        <PageHeader header="Абонементы" />
        <div className="inputs">
          <FieldDTO
            type="text"
            component={TextInput}
            control={control}
            dtoObject={attributes.lpn}
            className="small no-border"
          />
          <FieldDTO
            type="text"
            component={TextInput}
            control={control}
            dtoObject={attributes.card_uid}
            className="small no-border"
          />
          <FieldDTO
            type="text"
            component={TextInput}
            control={control}
            dtoObject={attributes.comment}
            className="small no-border"
          />
          <SeparateBox />
          <IconBox icon="plus-add" onClick={handleCreate} />
        </div>
      </div>
      <div className="plp-table g-0">
        <div className="frame">
          <div className="sticky-table-wrapper custom-scroll-theme">
            <CustomizedGrid
              className="plp-grid"
              data={subscriptionList}
              columns={subscriptionColumns}
              name="subscription-list"
              withSettingsColumn={false}
              onClickByRow={(item, event) => handleView(item)(event)}
            />
          </div>
        </div>
        <Pagination meta={subscriptionListMeta} list={subscriptionList} handleChangeMeta={loadData} />
      </div>
    </div>
  );

  const isForm = showForm && (currentSubscription || isCreate);
  const isView = showView && currentSubscription;

  return (
    <div className="subscription-tab">
      <Loader global loading={loadingSubscriptionList || loadingCurrentSubscription || loadingCreateSubscription || loadingEditSubscription || loadingDeleteSubscription || loadingIntervalList || loadingCreateInterval || loadingEditInterval || loadingDeleteInterval} />
      {!isForm && !isView ? renderList() : null}
      {!isForm && isView ? <SubscriptionForm hasView loadData={loadData} handleEdit={handleEdit} handleClose={handleClose} /> : null}
      {isForm && !isView ? <SubscriptionForm loadData={loadData} handleEdit={handleEdit} handleClose={handleClose} /> : null}
    </div>
  );
}
